import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ConfirmProvider } from "@/components/feedback/ConfirmDialog";
import { ErrorBoundary } from "@/components/feedback/ErrorBoundary";
import { ToastHost } from "@/components/feedback/ToastHost";
import { DirectionProvider } from "@/components/i18n/DirectionProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/stores/authStore";
import { ThemeProvider } from "@/stores/themeStore";
import { attachServerBundleLoader } from "@/i18n";
import "./styles/globals.css";

// Fetch the authoritative locale bundles from the authoring store at runtime.
attachServerBundleLoader();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <DirectionProvider>
              <ConfirmProvider>
                <TooltipProvider>
                  <App />
                  <ToastHost />
                </TooltipProvider>
              </ConfirmProvider>
            </DirectionProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);

